import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

import { browserLocalPersistence, setPersistence } from "firebase/auth";

// Which Firebase project this bundle talks to is decided by the .env file the
// build runs with (see .env.example / .env.staging.example) - never by this file.
// Nothing below defaults to production: a missing var throws at startup.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Realtime Database is optional: no app on this platform reads RTDB today, but
// the key was present in the old hardcoded config, so it is passed through when
// supplied rather than dropped. Note the SDK key is `databaseURL`, not
// `dataBaseURL` - the latter is silently ignored.
if (process.env.REACT_APP_FIREBASE_DATABASE_URL) {
  firebaseConfig.databaseURL = process.env.REACT_APP_FIREBASE_DATABASE_URL;
}

const REQUIRED_ENV_VARS = {
  apiKey: "REACT_APP_FIREBASE_API_KEY",
  authDomain: "REACT_APP_FIREBASE_AUTH_DOMAIN",
  projectId: "REACT_APP_FIREBASE_PROJECT_ID",
  storageBucket: "REACT_APP_FIREBASE_STORAGE_BUCKET",
  messagingSenderId: "REACT_APP_FIREBASE_MESSAGING_SENDER_ID",
  appId: "REACT_APP_FIREBASE_APP_ID"
};

const missingEnvVars = Object.entries(REQUIRED_ENV_VARS)
  .filter(([configKey]) => !firebaseConfig[configKey])
  .map(([, envVar]) => envVar);

if (missingEnvVars.length > 0) {
  throw new Error(
    `Missing required Firebase env vars: ${missingEnvVars.join(", ")}. ` +
      "Copy .env.example to .env and fill in the target project's values. " +
      "Refusing to start rather than fall back to production."
  );
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);

setPersistence(auth, browserLocalPersistence);

export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider("apple.com");

export default app;
